// extracted by mini-css-extract-plugin
export default {"videeSectionBack":"VideoSection_videeSectionBack__GqKnl","videoCloseButton":"VideoSection_videoCloseButton__55zbj","videoSection":"VideoSection_videoSection__ET-LC"};